<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <section class="modal-card-body">
        <button
          class="delete btn-right"
          aria-label="close"
          @click="closeModal"
        ></button>
        <div class="carousel-body">
          <b-carousel
            :indicator="true"
            :indicator-inside="true"
            :indicator-mode="'hover'"
            :indicator-style="'is-lines'"
            :pause-hover="true"
            :pause-info="false"
          >
            <b-carousel-item v-for="(carousel, i) in carouselData" :key="i">
              <div class="card">
                <div class="card-image">
                  <figure class="image">
                    <img :src="url + carousel.image" />
                  </figure>
                </div>
                <div class="card-content">
                  <div class="content">
                    <div v-html="carousel.html"></div>
                  </div>
                </div>
              </div>
            </b-carousel-item>
          </b-carousel>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarouselImg',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    carouselData: {
      type: Array
    },
    act: {
      type: String
    }
  },
  data() {
    return {
      url: process.env.VUE_APP_BASE_API
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', this.act)
    }
  }
}
</script>

<style scoped lang="scss">
img {
  width: auto;
  height: 60px;
  margin-top: 20px;
  display: block;
  margin: 0 auto;
}

.modal-card-body {
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}
.btn-right {
  float: right;
  background: $primary-button;
}
.btn-right:before,
.btn-right:after {
  background-color: white;
}
.carousel-body {
  position: relative;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  display: block;
  padding: 10px;
  margin-bottom: 20px;
  margin-top: 20px;
  img {
    width: auto;
    height: 300px;
  }

  .description {
    margin-top: 30px;
    text-align: left;
    color: black;
  }
}
</style>
